import { defineStore } from 'pinia';
import { getInitialLocale, SUPPORTED_LOCALES } from '@/plugins/i18n';

export type LanguageOption = (typeof SUPPORTED_LOCALES)[number];

export const useLangStore = defineStore({
  id: 'language',
  state: () => ({
    language: getInitialLocale(),
  }),
  actions: {
    setLanguage(newLang: LanguageOption) {
      this.language = newLang;
      localStorage.setItem('language', newLang);
    },
  },
});
